var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTreasureMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdecf"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.145,
    x2: 354.941,
    xlinkHref: "#lg1",
    y1: -19.286,
    y2: 472.809
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faa68e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faa68e"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 351.193,
    x2: -365.651,
    xlinkHref: "#lg2",
    y1: 241.675,
    y2: -97.003
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.169,
    x2: 360.48,
    xlinkHref: "#lg2",
    y1: 353.143,
    y2: -293.839
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.612,
    x2: 340.728,
    xlinkHref: "#lg2",
    y1: 336.615,
    y2: -212.183
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.787,
    x2: 30.096,
    xlinkHref: "#lg2",
    y1: 183.408,
    y2: 104.718
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.533,
    x2: 45.912,
    xlinkHref: "#lg2",
    y1: 184.154,
    y2: 120.533
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.496,
    x2: 71.831,
    xlinkHref: "#lg3",
    y1: 145.643,
    y2: 156.521
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.309,
    x2: 85.027,
    y1: 166.93,
    y2: 159.648
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(0 -1 1 0 619.019 296.795)",
    gradientUnits: "userSpaceOnUse",
    x1: 151.039,
    x2: 140.374,
    xlinkHref: "#lg3",
    y1: -547.997,
    y2: -537.119
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 467.469,
    x2: 406.462,
    xlinkHref: "#lg2",
    y1: 372.62,
    y2: 311.613
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 455.825,
    x2: 425.916,
    xlinkHref: "#lg2",
    y1: 360.975,
    y2: 331.067
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4651,
    stopColor: "#2d986c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077565"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.132,
    x2: 419.467,
    xlinkHref: "#lg4",
    y1: 323.808,
    y2: 334.687
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.945,
    x2: 432.662,
    y1: 345.096,
    y2: 337.813
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005a01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005a01"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(0 -1 1 0 619.019 296.795)",
    gradientUnits: "userSpaceOnUse",
    x1: -27.127,
    x2: -37.792,
    xlinkHref: "#lg4",
    y1: -200.361,
    y2: -189.483
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.755,
    x2: 496.853,
    xlinkHref: "#lg1",
    y1: 44.02,
    y2: 332.579
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 398.757,
    x2: 337.334,
    xlinkHref: "#lg2",
    y1: 179.558,
    y2: 118.135
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.049,
    x2: 366.698,
    xlinkHref: "#lg2",
    y1: 182.848,
    y2: 147.498
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.785,
    x2: 356.12,
    xlinkHref: "#lg5",
    y1: 136.111,
    y2: 146.989
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 376.598,
    x2: 369.315,
    y1: 157.398,
    y2: 150.115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(0 -1 1 0 619.019 296.795)",
    gradientUnits: "userSpaceOnUse",
    x1: 160.571,
    x2: 149.906,
    xlinkHref: "#lg5",
    y1: -263.709,
    y2: -252.83
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.778,
    x2: 119.915,
    xlinkHref: "#lg6",
    y1: 182.468,
    y2: 182.468
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.972,
    x2: 374.525,
    xlinkHref: "#lg6",
    y1: 285.888,
    y2: 285.888
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 378.794,
    x2: 404.292,
    xlinkHref: "#lg6",
    y1: 363.984,
    y2: 363.984
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bdc2d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2367,
    stopColor: "#b5b6c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6651,
    stopColor: "#9e96a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a7889"
  }))), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.945,
    x2: 306.347,
    xlinkHref: "#lg7",
    y1: 193.152,
    y2: 251.88
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.239,
    x2: 268.64,
    xlinkHref: "#lg7",
    y1: 213.956,
    y2: 272.683
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.417,
    x2: 344.819,
    xlinkHref: "#lg7",
    y1: 171.926,
    y2: 230.654
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m459.758 67.878c-3.42 6.66-11.221 9.788-18.295 7.336l-4.923-1.706c-3.941-1.366-8.243-1.262-12.114.294-5.648 2.271-12.075 1.404-16.92-2.282l-5.495-4.181c-5.097-3.878-11.325-5.978-17.729-5.978h-136.361c-5.001 0-9.478 3.102-11.234 7.785l-7.615 20.308c-.809 2.157-3.786 2.348-4.864.312l-7.232-13.66c-1.106-2.09-3.849-2.643-5.68-1.146-1.938 1.586-4.857.858-5.824-1.452l-2.002-4.782c-1.868-4.461-6.231-7.365-11.067-7.365h-130.523c-3.576 0-6.849 2.008-8.47 5.195l-6.6 12.982c-1.598 3.142-6.257 2.536-6.997-.91l-2.099-9.761c-.941-4.378-4.812-7.505-9.29-7.505h-20.282c-4.497-.001-8.142 3.644-8.142 8.141v370.994c0 4.497 3.645 8.142 8.142 8.142h23.172c4.498 0 8.618-2.516 10.673-6.517 3.719-7.242 12.2-10.643 19.892-7.976l3.846 1.333c3.941 1.366 8.243 1.262 12.114-.294 5.648-2.271 12.075-1.404 16.92 2.282l6.827 5.195c5.097 3.878 11.325 5.978 17.729 5.978h134.649c5.001 0 9.478-3.102 11.234-7.785l7.996-21.322c.809-2.157 3.786-2.348 4.864-.312l7.232 13.66c1.106 2.09 3.849 2.643 5.68 1.146 1.938-1.586 4.857-.858 5.824 1.452l2.426 5.796c1.867 4.461 6.231 7.365 11.067 7.365h129.583c3.576 0 6.849-2.008 8.47-5.195l7.116-13.995c1.598-3.142 6.257-2.536 6.997.91l2.316 10.775c.941 4.378 4.812 7.505 9.29 7.505h27.799c4.497 0 8.142-3.645 8.142-8.142v-370.995c0-4.497-3.645-8.142-8.142-8.142h-31.427c-4.498 0-8.618 2.516-10.673 6.517z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m501.858 61.361h-31.427c-4.498 0-8.618 2.516-10.673 6.517-3.42 6.661-11.221 9.788-18.295 7.336l-4.923-1.706c-3.941-1.366-8.243-1.262-12.114.294-5.649 2.271-12.075 1.404-16.92-2.282l-5.495-4.181c-5.097-3.878-11.325-5.978-17.729-5.978h-129.282v387.229c4.575-.396 8.564-3.38 10.198-7.737l7.996-21.322c.809-2.157 3.786-2.348 4.864-.312l7.232 13.66c1.106 2.09 3.849 2.643 5.679 1.146 1.938-1.586 4.857-.858 5.824 1.452l2.426 5.796c1.867 4.461 6.231 7.365 11.067 7.365h129.583c3.576 0 6.849-2.008 8.47-5.195l7.116-13.995c1.598-3.142 6.257-2.536 6.997.91l2.316 10.775c.941 4.378 4.812 7.505 9.29 7.505h27.799c4.497 0 8.142-3.645 8.142-8.142v-370.993c.001-4.497-3.644-8.142-8.141-8.142z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 255v185.497c0 4.497 3.645 8.142 8.142 8.142h23.172c4.498 0 8.618-2.516 10.673-6.517 3.719-7.242 12.2-10.643 19.892-7.976l3.846 1.333c3.941 1.366 8.243 1.262 12.114-.294 5.649-2.271 12.075-1.404 16.92 2.282l6.827 5.195c5.097 3.878 11.325 5.978 17.729 5.978h134.649c5.001 0 9.478-3.102 11.234-7.785l7.996-21.322c.809-2.157 3.786-2.348 4.864-.312l7.232 13.66c1.106 2.09 3.849 2.643 5.679 1.146 1.938-1.586 4.857-.858 5.824 1.452l2.426 5.796c1.867 4.461 6.231 7.365 11.067 7.365h129.583c3.576 0 6.849-2.008 8.47-5.195l7.116-13.995c1.598-3.142 6.257-2.536 6.997.91l2.316 10.775c.941 4.378 4.812 7.505 9.29 7.505h27.799c4.497 0 8.142-3.645 8.142-8.142v-185.498z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.142 448.639h23.172c4.498 0 8.618-2.516 10.673-6.517 3.719-7.242 12.2-10.643 19.892-7.976l3.846 1.333c3.941 1.366 8.243 1.262 12.114-.294 5.649-2.271 12.075-1.404 16.92 2.282l6.827 5.195c5.097 3.878 11.325 5.978 17.729 5.978h134.649c5.001 0 9.478-3.102 11.234-7.785l7.996-21.322c.809-2.157 3.786-2.348 4.864-.312l7.232 13.66c1.106 2.09 3.849 2.643 5.679 1.146 1.938-1.586 4.857-.858 5.824 1.452l2.426 5.796c1.867 4.461 6.231 7.365 11.067 7.365h129.583c3.576 0 6.849-2.008 8.47-5.195l7.116-13.995c1.598-3.142 6.257-2.536 6.997.91l2.316 10.775c.941 4.378 4.812 7.505 9.29 7.505h27.799c4.497 0 8.142-3.645 8.142-8.142v-185.498c-126.728-57.715-166.909 75.941-201.335 29.364s-66.828-53.665-109.354-53.665-25.314-84.041-99.111-109.354c-51.258-17.582-84.606 27.863-100.199 57.267v261.885c0 4.497 3.645 8.142 8.142 8.142z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m56.662 171.59 40.351-40.35 47.62 47.62-40.394 40.394z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m123.568 198.189c-4.248 4.248-11.136 4.248-15.384 0l-25.009-25.009c-4.248-4.248-4.248-11.136 0-15.384 4.248-4.248 11.136-4.248 15.384 0l25.009 25.009c4.249 4.248 4.249 11.136 0 15.384z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.013 171.633c-4.248 4.248-11.136 4.248-15.384 0l-25.009-25.009c-4.248-4.248-4.248-11.136 0-15.384 4.248-4.248 11.136-4.248 15.384 0l25.009 25.009c4.248 4.248 4.248 11.136 0 15.384z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.193 162.197 9.436 9.436c4.248 4.248 11.136 4.248 15.384 0s4.248-11.136 0-15.384l-9.436-9.436z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.013 131.24c4.248 4.248 4.248 11.136 0 15.384l-25.009 25.009c-4.248 4.248-11.136 4.248-15.384 0-4.248-4.248-4.248-11.136 0-15.384l25.009-25.009c4.248-4.249 11.135-4.249 15.384 0z",
    fill: "url(#SVGID_9_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m404.298 349.756 40.35-40.351 47.621 47.621-40.394 40.394z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m471.204 376.355c-4.248 4.248-11.136 4.248-15.384 0l-25.009-25.009c-4.248-4.248-4.248-11.136 0-15.384 4.248-4.248 11.136-4.248 15.384 0l25.009 25.009c4.248 4.248 4.248 11.135 0 15.384z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m444.648 349.799c-4.248 4.248-11.136 4.248-15.384 0l-25.009-25.009c-4.248-4.248-4.248-11.136 0-15.384 4.248-4.248 11.136-4.248 15.384 0l25.009 25.009c4.249 4.248 4.249 11.135 0 15.384z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.828 340.363 9.436 9.436c4.248 4.248 11.136 4.248 15.384 0s4.248-11.136 0-15.384l-9.436-9.436z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m444.648 309.405c4.248 4.248 4.248 11.136 0 15.384l-25.009 25.009c-4.248 4.248-11.136 4.248-15.384 0-4.248-4.248-4.248-11.136 0-15.384l25.009-25.009c4.248-4.248 11.136-4.248 15.384 0z",
    fill: "url(#SVGID_14_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m501.858 61.361h-31.427c-4.498 0-8.618 2.516-10.673 6.517-3.42 6.661-11.221 9.788-18.295 7.336l-4.923-1.706c-3.941-1.366-8.243-1.262-12.114.294-5.649 2.271-12.075 1.404-16.92-2.282l-5.495-4.181c-5.097-3.878-11.325-5.978-17.729-5.978h-77.866c.663 18.557-1.688 43.097-15.978 57.958-25.314 26.326-52.311 97.204-16.537 112.392s80.21-25.314 122.795 11.138c28.222 24.157 79.536 15.845 113.303-5.768v-167.578c.001-4.497-3.644-8.142-8.141-8.142z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m340.95 162.058 40.351-40.351 47.62 47.621-40.394 40.394z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m407.857 188.657c-4.248 4.248-11.136 4.248-15.384 0l-25.009-25.009c-4.248-4.248-4.248-11.136 0-15.384 4.248-4.248 11.136-4.248 15.384 0l25.009 25.009c4.248 4.248 4.248 11.135 0 15.384z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.301 162.101c-4.248 4.248-11.136 4.248-15.384 0l-25.009-25.009c-4.248-4.248-4.248-11.136 0-15.384 4.248-4.248 11.136-4.248 15.384 0l25.009 25.009c4.248 4.248 4.248 11.136 0 15.384z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.481 152.665 9.436 9.436c4.248 4.248 11.136 4.248 15.384 0s4.248-11.136 0-15.384l-9.436-9.436z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.301 121.707c4.248 4.248 4.248 11.136 0 15.384l-25.009 25.009c-4.248 4.248-11.136 4.248-15.384 0-4.248-4.248-4.248-11.136 0-15.384l25.009-25.009c4.248-4.248 11.136-4.248 15.384 0z",
    fill: "url(#SVGID_20_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m112.321 194.536c-1.944 0-3.887-.742-5.37-2.225l-8.949-8.95c-2.966-2.965-2.965-7.774 0-10.739 2.966-2.965 7.775-2.964 10.739.001l8.949 8.95c2.966 2.965 2.965 7.774 0 10.739-1.482 1.483-3.426 2.224-5.369 2.224z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.939 378.409c-.277 0-.558-.016-.84-.046-9.901-1.091-19.239-5.576-26.294-12.63l-.124-.124c-2.965-2.966-2.965-7.774 0-10.74 2.966-2.964 7.774-2.964 10.74 0l.124.124c4.688 4.689 10.642 7.55 17.217 8.273 4.169.459 7.176 4.211 6.717 8.38-.428 3.886-3.718 6.763-7.54 6.763zm-226.691-3.126c-9.057 0-18.013-2.309-25.898-6.676-3.668-2.032-4.995-6.654-2.963-10.322 2.032-3.669 6.654-4.995 10.323-2.963 6.025 3.337 12.95 4.993 19.871 4.751 4.182-.116 7.704 3.142 7.845 7.335.141 4.192-3.142 7.704-7.335 7.845-.614.02-1.229.03-1.843.03zm20.652-4.893c-2.777 0-5.452-1.53-6.788-4.179-1.887-3.745-.381-8.311 3.364-10.199 3.627-1.828 6.939-4.228 9.844-7.132l7.179-7.181c2.965-2.964 7.774-2.964 10.739 0 2.966 2.966 2.966 7.774 0 10.74l-7.18 7.181c-4.05 4.049-8.675 7.398-13.748 9.954-1.095.554-2.261.816-3.41.816zm-57.632-13.828c-2.332 0-4.633-1.07-6.121-3.092-5.735-7.789-9.241-17.014-10.142-26.678-.389-4.176 2.681-7.877 6.857-8.265 4.169-.389 7.876 2.682 8.265 6.857.644 6.916 3.151 13.515 7.249 19.082 2.487 3.377 1.765 8.131-1.613 10.618-1.354.997-2.932 1.478-4.495 1.478zm227.764-2.748c-1.943 0-3.887-.742-5.37-2.224l-17.523-17.523c-2.965-2.966-2.965-7.774 0-10.74 2.966-2.964 7.774-2.964 10.74 0l17.523 17.523c2.965 2.966 2.965 7.774 0 10.74-1.483 1.482-3.427 2.224-5.37 2.224zm-139.518-15.093c-1.181 0-2.379-.277-3.498-.859-3.721-1.936-5.168-6.521-3.232-10.242 3.386-6.508 5.484-13.53 6.237-20.869.428-4.173 4.155-7.205 8.329-6.78 4.172.428 7.208 4.157 6.78 8.329-.949 9.255-3.597 18.114-7.872 26.331-1.354 2.599-4.002 4.09-6.744 4.09zm107.977-16.448c-1.943 0-3.887-.742-5.37-2.224l-17.523-17.523c-2.965-2.966-2.965-7.774 0-10.74 2.966-2.964 7.774-2.964 10.74 0l17.523 17.523c2.965 2.966 2.965 7.774 0 10.74-1.483 1.482-3.427 2.224-5.37 2.224zm-202.527-8.114c-.836 0-1.685-.138-2.518-.431-3.957-1.391-6.037-5.726-4.646-9.682 2.665-7.582 6.916-14.328 12.636-20.048l3.026-3.027c2.965-2.964 7.774-2.964 10.739 0 2.966 2.966 2.966 7.774 0 10.74l-3.026 3.026c-4.099 4.099-7.143 8.925-9.047 14.344-1.098 3.124-4.031 5.078-7.164 5.078zm100.661-18.766c-3.545 0-6.715-2.495-7.438-6.104-1.447-7.223-4.21-14.008-8.213-20.165-2.286-3.516-1.288-8.22 2.228-10.506 3.516-2.285 8.22-1.289 10.506 2.228 5.055 7.776 8.545 16.342 10.371 25.461.824 4.112-1.842 8.113-5.955 8.937-.503.1-1.005.149-1.499.149zm70.323-4.662c-1.943 0-3.887-.742-5.37-2.224l-4.789-4.789c-3.94-3.94-8.232-7.543-12.758-10.707-3.438-2.403-4.276-7.137-1.872-10.575 2.403-3.438 7.137-4.277 10.575-1.872 5.252 3.671 10.229 7.848 14.796 12.414l4.789 4.789c2.965 2.966 2.965 7.774 0 10.74-1.484 1.482-3.428 2.224-5.371 2.224zm-142.854-10.561c-2.155 0-4.295-.912-5.797-2.685-2.712-3.2-2.316-7.992.884-10.703 6.787-5.752 14.257-10.66 22.201-14.59 3.759-1.858 8.315-.318 10.174 3.44 1.859 3.759.319 8.315-3.44 10.174-6.838 3.382-13.27 7.609-19.116 12.563-1.428 1.21-3.172 1.801-4.906 1.801zm107.037-15.489c-1.022 0-2.06-.208-3.055-.646-6.984-3.074-14.353-5.295-21.902-6.599-4.133-.715-6.904-4.644-6.19-8.777s4.646-6.898 8.777-6.19c8.764 1.515 17.321 4.094 25.434 7.665 3.839 1.69 5.581 6.171 3.891 10.01-1.252 2.845-4.036 4.537-6.955 4.537zm-67.875-5.085c-3.347 0-6.411-2.229-7.327-5.614-.892-3.3.533-6.678 3.283-8.409l-7.701-7.701c-2.966-2.966-2.966-7.774 0-10.74 2.965-2.964 7.774-2.964 10.739 0l14.525 14.526c3.579-.432 7.18-.689 10.787-.768.056-.001.114-.002.17-.002 4.117 0 7.498 3.291 7.589 7.427.092 4.194-3.232 7.667-7.425 7.759-3.392.074-6.776.331-10.136.767-1.405.691-2.98.923-4.496.693-2.699.484-5.376 1.083-8.022 1.798-.663.178-1.33.264-1.986.264zm-20.393-33.519c-1.943 0-3.887-.742-5.37-2.224l-17.523-17.523c-2.966-2.966-2.966-7.774 0-10.739 2.965-2.966 7.774-2.965 10.739-.001l17.523 17.523c2.966 2.966 2.966 7.774 0 10.739-1.482 1.484-3.425 2.225-5.369 2.225z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386.395 375.2c-2.857 0-5.592-1.619-6.883-4.376-1.778-3.799-.139-8.32 3.659-10.098 3.024-1.415 5.769-3.344 8.157-5.733 2.966-2.964 7.774-2.964 10.74 0 2.965 2.966 2.965 7.774 0 10.74-3.641 3.64-7.832 6.583-12.458 8.749-1.042.486-2.137.718-3.215.718z",
    fill: "url(#SVGID_23_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m283.142 183.045-6.157 2.82c-5.87 2.69-11.52 5.9-16.791 9.543-3.452 2.385-4.315 7.114-1.93 10.564 2.385 3.451 7.115 4.315 10.565 1.93 4.543-3.139 9.415-5.908 14.481-8.228l6.157-2.82c1.906-.874 3.279-2.438 3.956-4.259s.659-3.902-.213-5.809c-1.748-3.811-6.255-5.487-10.068-3.741z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m243.958 209.153c-6.174 6.36-11.573 13.482-16.047 21.169-2.103 3.625-.881 8.274 2.744 10.383s8.273.881 10.383-2.744c3.853-6.622 8.502-12.755 13.817-18.23.757-.78 1.314-1.681 1.67-2.639 1.017-2.737.4-5.935-1.829-8.099-3.009-2.921-7.816-2.849-10.738.16z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.33 164.493c-3.171-2.745-7.967-2.4-10.712.771-4.329 5.002-10.064 8.279-16.586 9.476l-.172.031c-4.125.759-6.854 4.717-6.098 8.841.758 4.126 4.716 6.855 8.841 6.098l.172-.032c9.813-1.803 18.807-6.943 25.326-14.474.186-.215.358-.438.515-.665 2.171-3.146 1.67-7.488-1.286-10.046z",
    fill: "url(#SVGID_26_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTreasureMap);
export default __webpack_public_path__ + "static/media/icon-treasure-map.dc7bd008b602ad8b9ae5d909e0db7459.svg";
export { ForwardRef as ReactComponent };